import React from "react";
import { Container, Title, Iframe } from "./styles";

const PreRegistrationPage: React.FC = () => {
  return (
    <Container>
      <Title>Préinscription</Title>

      {/* Formulaire officiel Meeko */}
      <Iframe
        src="https://micro-creche-meli-melo-2.meeko.site/iframe/registration/one"
        title="Formulaire de préinscription Meeko"
        loading="lazy"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
      />
      {/* Lien fallback si l'iframe ne charge pas */}
      <p style={{ textAlign: "center", marginTop: 16 }}>
        Si le formulaire ne s’affiche pas,&nbsp;
        <a
          href="https://micro-creche-meli-melo-2.meeko.site/iframe/registration/one"
          target="_blank"
          rel="noopener noreferrer"
        >
          cliquez ici
        </a>
        .
      </p>
    </Container>
  );
};

export default PreRegistrationPage;
